<script>
import { mapState } from 'vuex'
import moment from 'moment'
import CredentialDetail from '@/components/identity/CredentialDetail'

export default {
  data() {
    return {
      identityName: '',
      identityDescription: '',
      identityValidity: '',
      identityLoader: false,
      selectedIdentityType: {},
      validity: Date.now(),
      credential: []
    }
  },

  methods: {
    async createIdentity() {
      this.identityLoader = true
      let credentials = {}
      this.identityStructure.forEach(element => {
        if (element.key === this.selectedIdentityType.key) {
          let credential = {}
          this.credential.forEach(option => {
            if (option.options) {
              credential[option.fieldName] = option.value.key
            } else {
              credential[option.fieldName] = option.value
            }
          })
          credentials[element.fieldName] = credential
        } else {
          credentials[element.fieldName] = null
        }
      })
      let identity = {
        name: this.identityName,
        description: this.identityDescription,
        identityType: this.selectedIdentityType.key,
        validity: this.validity,
        credential: credentials
      }
      try {
        let response = await this.$store.dispatch('saveIdentity', identity)
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Identity saved Successfully',
          description:
            'Identity ' + response.hexId + ' has been saved Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.$store.dispatch('fetchIdentities')
        this.$router.push({ name: 'identity-list' }).catch()
      } catch (e) {
        this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to save Identity',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.identityLoader = false
    },
    credentialUpdated(credential) {
      this.credential = credential
    },
    backtolist() {
      this.$router.replace({ name: 'identity-list' }).catch()
    }
  },

  computed: {
    ...mapState({
      identityTypes: state => state.enums.identityTypes,
      identityStructure: state => state.identities.identityStructure
    }),
    selectedIdentityStructureOptions() {
      let selectedIdentityStructure = this.identityStructure.find(element => {
        return element.key === this.selectedIdentityType.key
      })
      if (selectedIdentityStructure) {
        return selectedIdentityStructure.options
      } else {
        return []
      }
    }
  },

  created() {
    this.$store.dispatch('fetchIdentities')
    this.$store.dispatch('fetchIdentityStructure')
    this.$store.dispatch('fetchIdentityTypes')
  },

  components: {
    CredentialDetail
  }
}
</script>

<template>
  <v-card class="card--flex-toolbar">
    <v-toolbar card dense>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="backtolist">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <span>Back</span>
      </v-tooltip>
      <v-toolbar-title class="body-2">
        Create Identity
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 sm3>
          <v-subheader v-text="'Identity Name'" />
        </v-flex>
        <v-flex xs12 sm9>
          <v-text-field
            color="secondary"
            label="Identity Name"
            hint="Enter a name for the identity"
            persistent-hint
            v-model="identityName"
            autofocus
          >
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm3>
          <v-subheader v-text="'Identity Description'" />
        </v-flex>
        <v-flex xs12 sm9>
          <v-text-field
            color="secondary"
            label="Identity Description"
            hint="Enter description for the identity"
            persistent-hint
            v-model="identityDescription"
          >
          </v-text-field>
        </v-flex>
        <!--        <v-flex xs12 sm3>-->
        <!--          <v-subheader v-text="'Identity Validity'"></v-subheader>-->
        <!--        </v-flex>-->
        <!--        <v-flex xs12 sm9>-->
        <!--          <v-text-field-->
        <!--            color="secondary"-->
        <!--            label="Identity Validity"-->
        <!--            hint="Enter the validity period identity"-->
        <!--            persistent-hint-->
        <!--            v-model="identityValidity"-->
        <!--          >-->
        <!--          </v-text-field>-->
        <!--        </v-flex>-->
        <v-flex xs12 sm3 mt-4>
          <v-subheader v-text="'Identity Type'" />
        </v-flex>
        <v-flex xs12 sm9 mt-4>
          <v-select
            color="secondary"
            item-text="friendlyName"
            item-value="key"
            :items="identityTypes"
            v-model="selectedIdentityType"
            label="Identity Type"
            return-object
          >
          </v-select>
        </v-flex>
        <v-flex xs12 sm3 mt-4>
          <v-subheader>Authorization Params</v-subheader>
        </v-flex>
        <v-flex xs12 sm9 mt-4 v-if="selectedIdentityType">
          <credential-detail
            :value="selectedIdentityStructureOptions"
            @input="credentialUpdated"
          />
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-layout justify-center>
        <v-btn
          @click="createIdentity"
          :outline="$vuetify.dark"
          :class="
            $vuetify.dark ? 'secondary text-capitalize' : 'text-capitalize'
          "
          accent
          :loading="identityLoader"
          >Create Identity
        </v-btn>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
